import { render, staticRenderFns } from "./EventsIndividualBookings.vue?vue&type=template&id=891ee99e&scoped=true&"
import script from "./EventsIndividualBookings.vue?vue&type=script&lang=ts&"
export * from "./EventsIndividualBookings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891ee99e",
  null
  
)

export default component.exports